/**
 * Add-on pricing per service user (in GBP)
 */
export const ADDON_PRICES = {
  emar: 3,
  family: 2
}

/**
 * Calculate Family portal add-on pricing
 *
 * @param numUsers - Number of active SU/resident
 * @returns Price in GBP (£2 per SU)
 */
export function calculateFamilyPrice(numUsers: number): number {
  return ADDON_PRICES.family * (numUsers || 1)
}
